import {gql} from '@apollo/client';

export const QUERY_THEME_LIST = gql`
  query ThemeLits {
    themeList {
      id
      name
      content
      topicsCount
      image {
        id
        path
      }
    }
  }
`;

export const QUERY_THEME_DETAIL = gql`
  query ThemeDetail($id: ID!) {
    themeDetail(id: $id) {
      id
      name
      topicsCount
      content
      image {
        id
        path
      }
      topics {
        id
        name
      }
    }
  }
`;
